// extracted by mini-css-extract-plugin
export default {"tabWrapper":"poolsTab_tabWrapper__bjjc9"};